export default __webpack_public_path__ + "static/media/iq-img3-w.5336a957.png";